import { useCallback, useRef } from 'react';
import { debugHook } from './hookUtils';
export default debugHook(useStableCallback, 'useStableCallback');
/**
 * A lightweight hook to wrap a callback function in a reference, so that
 * whenever the function is called it will invoke the latest version of the callback function
 *
 * This is useful where your callback is dependent on some external (probably async) data which
 * changes in response to the component you are passing the callback to.
 *
 * @param {Function} callback
 */

export function useStableCallback(callback) {
  const callbackRef = useRef();
  callbackRef.current = callback;
  const wrappedCallback = useCallback((...args) => callbackRef.current(...args), []);
  return wrappedCallback;
}